<template>
  <div v-if="audit">
    <div class="entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{  audit.id ? $t('addEditAudit.title.edit',
                { code: audit.code }) : $t('addEditAudit.title.add')}}
                <b-tag v-if="getLibelleEtat"
                       type="has-background-subMenu"
                       class="has-text-white mgl-5px">
                  {{ getLibelleEtat }}
                </b-tag>
              </h1>
              <breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
        <div class="level-right">
          <a class="button" @click="retour">
            {{ $t('general.button.cancel') }}
          </a>
          <a class="button is-addOrEdit mgl-10px"
             @click="checkPermissions(constantes.ORDRE_TRAVAIL_AUDIT.maj) ? save()
                  : showPopUp()">
            {{ $t('general.button.sauvegarder') }}
          </a>
          <piece-jointe-button
            class="mgl-10px mgr-1"
            :perm="constantes.ORDRE_TRAVAIL_AUDIT.maj">
          </piece-jointe-button>
        </div>
      </div>
      <error-msg-component :messages="messages"
                           :error="error"
                           :title="'general.problemOccurred'"
                           :withEmplyFields="true"
                           :messagesChampsVide="messagesChampsVide"
                           :champsVide="champsVide"
                           @close="error = $event"/>
      <div class="tab mgh-0">
        <ul>
          <li :class="{'is-active': activeTab === 'audit'}"
              @click="activeTab = 'audit'">
            {{ $t('addEditAudit.onglet.audit') }}
          </li>
          <li :class="{'is-active': activeTab === 'patrimoine'}"
              @click="activeTab = 'patrimoine'">
            {{ $t('addEditAudit.onglet.patrimoine') }}
          </li>
        </ul>
      </div>
    </div>
    <component :is="activeTab"
               :audit="audit">
    </component>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import breadcrumb from '@/components/general/breadcrumb';
import audit from '@/components/logistique/audit/addEdit/audit/audit';
import patrimoine from '@/components/logistique/audit/addEdit/patrimoine/patrimoine';
import { ORDRE_TRAVAIL_AUDIT } from '@/configuration/logistique/permissionsLogistiqueConf';
import { LIST_ETAT_AUDIT } from '@/configuration/logistique/audit/auditConf';
import genererAudit from '@/services/logistique/audit/genererObject/genererAudit';
import messageErreur from '@/services/general/messageErreur';
import { get, create, update } from '@/api/logistique/audit';
import transformGetAudit from '@/services/logistique/audit/transformGetAudit';
import preparationEnvoieAuBackAudit from '@/services/logistique/audit/preparationEnvoieAuBackAudit';
import cloneDeep from 'lodash/cloneDeep';
import messageSucces from '@/services/general/messageSucces';
import validation from '@/services/logistique/audit/validation/validation';
import validationGeneral from '@/services/validation/validation';
import translate from '@/services/logistique/audit/validation/translate';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import pieceJointeButton from '@/components/general/button/pieceJointeButton';

const Societe = createNamespacedHelpers('societe');
const Audit = createNamespacedHelpers('audit');
const Permissions = createNamespacedHelpers('permissions');
const Attachments = createNamespacedHelpers('attachments');
const User = createNamespacedHelpers('user');

export default {
  data() {
    return {
      audit: null,
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      error: false,
      activeTab: 'audit',
      fromTab: null,
      constantes: {
        ORDRE_TRAVAIL_AUDIT,
      },
    };
  },
  components: {
    patrimoine,
    audit,
    breadcrumb,
    errorMsgComponent,
    pieceJointeButton,
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      societeActive: 'societeActive',
      agencesSelectionnees: 'agenceActive',
    }),
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Audit.mapGetters({
      auditCourant: 'auditCourant',
    }),
    ...User.mapGetters({
      utilisateur: 'user',
    }),
    breadcrumb() {
      return [
        { title: this.$t('general.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('addEditAudit.breadcrumb.liste'), route: { name: 'l.logistique.ordre_travail_audit' }, isActive: false },
        { title: this.$t('addEditAudit.breadcrumb.' + (this.audit.id ? 'edit' : 'add')), route: '', isActive: true },
      ];
    },
    getLibelleEtat() {
      const etatFind = LIST_ETAT_AUDIT.find((etat) => {
        return etat.code === this.audit.etat;
      });
      return etatFind ? this.$i18n.t(etatFind.libelle) : null;
    },
  },
  methods: {
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Audit.mapActions({
      setAuditCourant: 'setAuditCourant',
    }),
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
      setAttachmentElementId: 'setElementId',
      insertAttachments: 'insert',
      updateAttachments: 'update',
    }),
    async save() {
      const loadingComponent = this.$buefy.loading.open();
      const auditToSave = preparationEnvoieAuBackAudit(cloneDeep(this.audit));
      try {
        let idAudit = null;
        if (this.$route.params.id) {
          idAudit = (await update(auditToSave)).data.result;
          await this.updateAttachments(idAudit);
          messageSucces(this.$i18n.t('addEditAudit.messages.success.update'));
        } else {
          idAudit = (await create(auditToSave)).data.result;
          await this.insertAttachments(idAudit);
          messageSucces(this.$i18n.t('addEditAudit.messages.success.create'));
        }
        await this.$router.push({ name: 'c.logistique.ordre_travail_audit', params: { id: idAudit } });
        loadingComponent.close();
      } catch (e) {
        if (e.response && e.response.data.error) {
          this.champsVide = [];
          this.messagesChampsVide = [];
          this.messages = [];
          validation(e.response, this.messages);
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translate);
          this.error = true;
        } else messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    genererAuditAndfillAgence() {
      const audit = genererAudit();
      if (this.agencesSelectionnees.find((agence) => {
        return agence.agenceId === this.utilisateur.agenceId;
      })) {
        audit.agenceId = this.utilisateur.agenceId;
      } else audit.agenceId = this.agencesSelectionnees[0].agenceId;
      audit.typeOtId = this.societeActive.typeOtAuditId;
      audit.societeId = this.societeActiveId;
      return audit;
    },
    retour() {
      if (window.history.length > 1) this.$router.go(-1);
      else this.$router.push({ name: 'l.logistique.ordre_travail_audit' });
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      if (this.auditCourant) {
        this.audit = this.auditCourant;
        if (this.audit.isFromPatrimoine) this.activeTab = 'patrimoine';
        this.audit.isFromPatrimoine = false;
        this.setAuditCourant(null);
      } else if (this.$route.params.id) {
        await this.setAttachmentContext({ module: 'OrdreTravail' });
        await this.setAttachmentElementId({ id: this.$route.params.id });
        const audit = (await get(this.$route.params.id)).data.result;
        this.audit = await transformGetAudit(audit);
        this.setInformationPage(this.$t('pageGeneral.modification', { item: this.audit.code }));
      } else {
        await this.setAttachmentContext({ module: 'OrdreTravail' });
        this.audit = this.genererAuditAndfillAgence();
        this.setInformationPage(this.$t('pageLogistique.audit.creation'));
      }
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw (e);
    }
  },
};

</script>
